import styled from 'styled-components';

export const StyledMainContainer = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;